export const REGION_LABELS: Record<string, string> = {
    'AOOS': 'Alaska (AOOS)',
    'CeNCOOS': 'Central and Northern California (CeNCOOS)',
    'GCOOS': 'Gulf of America (GCOOS)',
    'GLOS': 'Great Lakes (GLOS)',
    'MARACOOS': 'Mid-Atlantic (MARACOOS)',
    'NANOOS': 'Pacific Northwest (NANOOS)',
    'NERACOOS': 'Northeast (NERACOOS)',
    'PacIOOS': 'Pacific Islands (PacIOOS)',
    'SCCOOS': 'Southern California (SCCOOS)',
    'SECOORA': 'Southeast (SECOORA)',
    'SECOORA/GCOOS': 'Southeast/Gulf of America'
}